/*!
=========================================================
* Vue White Dashboard - v1.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/vue-white-dashboard
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-white-dashboard/blob/master/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Vue from "vue";
import VueRouter from "vue-router";
import SocialSharing from "vue-social-sharing";
import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";
import App from "./App.vue";
import "@/assets/scss/white-dashboard.scss";
import "@/assets/css/nucleo-icons.css";
import "@/assets/demo/demo.css";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import RTLPlugin from "./RTLPlugin";
import Notify from "@/components/NotificationPlugin";
import i18n from "./i18n";
import SideBar from "@/components/SidebarPlugin";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import {
	BootstrapVue,
	IconsPlugin
} from 'bootstrap-vue';
import "@/assets/css/kt.css";
import "@/assets/bootstrap-icons/font/bootstrap-icons.css"
Vue.config.productionTip = false;

import axios from "axios";
Vue.prototype.$axios = axios;
axios.defaults.withCredentials = true;

Vue.use(VueRouter);
// configure router
import routes from "./router";
const router = new VueRouter({
	routes, // short for routes: routes
	linkExactActiveClass: "active",
});

// 路由守卫
router.beforeEach((to, from, next) => {
	const isAuthenticated = !!sessionStorage.getItem('token'); // 检查是否存在 token
	if (to.matched.some(record => record.meta.requiresAuth)) {
		//console.log("if");
		// 如果该路由需要验证登录
		if (!isAuthenticated) {
			// 未登录，跳转到登录页面
			next('/login');
		} else {
			// 已登录，继续访问
			next();
		}
	} else {
		//console.log("else");
		// 不需要验证登录的页面，直接访问
		next();
	}
});

const test = false;

if (test) {
	Vue.prototype.$url = "http://localhost:8080"
	Vue.prototype.$serverUrl = "http://localhost:8083/kt-support";
} else {
	Vue.prototype.$url = "https://support.hzkete.com"
	Vue.prototype.$serverUrl = "https://support.hzkete.com/kt-support";
}

Vue.use(SocialSharing);
Vue.use(VueGitHubButtons, {
	useCache: true
});
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(RTLPlugin);
Vue.use(SideBar);
Vue.use(Notify);
Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
new Vue({
	router,
	i18n,
	render: (h) => h(App),
}).$mount("#app");